<template>
  <vue-form :state="formstate" @submit.prevent="submit()" >
    <b-row>
      <b-col>
        <b-form-group>
          <label>{{ $t('views.exsbpaymentsmade.edit.documentCashPaymentType') }}:</label><br>
          <b-form-radio-group buttons button-variant="outline-primary" v-model="item.type">
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.exsbpaymentsmade.edit.types.toAgreement')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.exsbpaymentsmade.edit.types.toInvoice')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col v-if="item.type === 0">
        <validate tag="div">
          <label>{{ $t('views.exsbpaymentsmade.list.agreement') }}:</label>
          <model-select required :placeholder="$t('views.exsbpaymentsmade.list.agreement')" v-model="item.idAgreement" :options="agreementOptions"></model-select>
        </validate>
      </b-col>
      <b-col v-else>
        <validate tag="div">
          <label>{{ $t('views.exsbpaymentsmade.list.invoice') }}:</label>
          <BaseSelectInput
            ref="invoiceInput"
            v-model="item.idEXSBInvoice"
            :search-callback="invoiceSearchCallback"
            :get-processed-text-custom="getInvoiceProcessedText"
            :display-values="['number', 'buyerName']"
            :query-param="'invoiceAutoCompleteFilter'"
            :placeholder-autocomplete="'Zacznij wpisywać numer lub odbiorcę faktury'"
            :is-auto-complete-mode="true"
          ></BaseSelectInput>
        </validate>
      </b-col>
      <b-col >
        <b-form-group>
          <validate tag="div">
            <label for="payments_type">{{ $t('views.exsbpaymentsmade.form.paymentsType') }}:</label>
            <model-select :placeholder="$t('views.exsbpaymentsmade.form.paymentsType')" v-model="item.paymentsType" :options="paymentsTypeOptionsTranslated"></model-select>
          </validate>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="6"  lg="4">
        <b-form-group>
          <validate tag="div">
            <label for="value">{{ $t('views.exsbpaymentsmade.list.value') }}:</label>
            <input :placeholder="$t('views.exsbpaymentsmade.list.value')" v-model="item.value" type="number" class="form-control" id="value">
          </validate>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="4">
        <b-form-group>
          <validate tag="div">
            <label for="value_provision">{{ $t('views.exsbpaymentsmade.form.valueProvision') }}:</label>
            <input :placeholder="$t('views.exsbpaymentsmade.form.valueProvision')" v-model="item.valueProvision" type="number" class="form-control" id="value_provision">
          </validate>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="4">
        <label>{{$t("views.exsbpaymentsmade.form.paymentDate")}}:</label>
        <VueCtkDateTimePicker :label="$t('views.exsbpaymentsmade.form.paymentDate')"
                              v-model="item.paymentDate"
                              no-header
                              format="YYYY-MM-DD"
                              :noButtonNow="true"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
                              :no-label="true"
        >
        </VueCtkDateTimePicker>
      </b-col>
      <b-col sm="12" md="6" lg="4">
        <b-form-group>
          <validate tag="div">
            <label for="from_account">{{ $t('views.exsbpaymentsmade.form.fromAccount') }}:</label>
            <input :placeholder="$t('views.exsbpaymentsmade.form.fromAccount')" v-model="item.fromAccount" type="text" class="form-control" id="from_account">
          </validate>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="4">
        <b-form-group>
          <validate tag="div">
            <label for="description">{{ $t('views.exsbpaymentsmade.form.description') }}:</label>
            <input :placeholder="$t('views.exsbpaymentsmade.form.description')" v-model="item.description" type="text" class="form-control" id="description">
          </validate>
        </b-form-group>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </vue-form>
</template>

<script>
import VueForm from 'vue-form'
import { ModelSelect } from 'vue-search-select'
import { mapGetters, mapActions } from 'vuex'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'

export default {
  name: 'Form',
  mixins: [VueForm],
  props: ['values', 'initialValues', 'handleSubmit'],
  components: {
    BaseSelectInput,
    ModelSelect,
    VueCtkDateTimePicker
  },
  data () {
    return {
      formstate: {}
    }
  },
  created () {
    this.fetchAgreementOptions()
  },
  watch: {
    'item.type': function (val) {
      if (val === 0) {
        this.item.idEXSBInvoice = null
      } else if (val === 1) {
        this.item.idAgreement = null
      }
    },
    'item.idAgreement': function (val) {
      if (val) {
        this.fetchAgreement(val)
      }
    },
    'item.idEXSBInvoice': function (val) {
      if (val) {
        this.fetchInvoice(val)
      }
    }
  },
  computed: {
    item () {
      return this.initialValues || this.values
    },
    paymentsTypeOptionsTranslated (state) {
      return state.paymentsTypeOptions.map(option => {
        return { value: option.value, text: this.$t(option.text) }
      })
    },
    ...mapGetters({
      agreementOptions: 'exsbpaymentsmade/list/agreementOptions',
      paymentsTypeOptions: 'exsbpaymentsmade/list/paymentsTypeOptions'
    })
  },
  methods: {
    submit () {
      if (this.formstate.$invalid) {
        return
      }
      this.handleSubmit()
    },
    async fetchAgreement (id) {
      let agreementData = await new ApiService(id).getResults()
      this.item.description = this.$t('views.exsbpaymentsmade.edit.types.toAgreement') + ': ' + agreementData.number
      if (agreementData.debtValue < 0) {
        this.item.value = Math.abs(agreementData.debtValue)
      }
    },
    async fetchInvoice (id) {
      let invoiceData = await new ApiService(id).getResults()
      this.item.description = this.$t('views.exsbpaymentsmade.edit.types.toInvoice') + ': ' + invoiceData.number
      this.item.value = invoiceData.toPay.toString()
    },
    async invoiceSearchCallback (params = {}) {
      let baseParams = { pagination: false, accepted: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_invoices', baseParams).getResults()
      return response.items
    },
    getInvoiceProcessedText (entry) {
      let textData = entry.buyerName + ' / '
      if (entry.nip) {
        textData += entry.nip + ' / '
      }
      textData += entry.number + ' (' + this.$t('views.exsbinvoices.show.toPay') + ': ' + entry.toPay + ' / ' +
        this.$t('views.exsbinvoices.form.invoiceValue') + ': ' + entry.totalValueBrutto + ')'
      return textData
    },
    ...mapActions({
      fetchAgreementOptions: 'exsbpaymentsmade/list/fetchAgreementOptions'
    })
  }
}
</script>

<style scoped>

</style>
